import { render, staticRenderFns } from "./LeftNavigation.vue?vue&type=template&id=dcdc7baa&lang=pug&"
import script from "./LeftNavigation.vue?vue&type=script&lang=js&"
export * from "./LeftNavigation.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcdc7baa')) {
      api.createRecord('dcdc7baa', component.options)
    } else {
      api.reload('dcdc7baa', component.options)
    }
    module.hot.accept("./LeftNavigation.vue?vue&type=template&id=dcdc7baa&lang=pug&", function () {
      api.rerender('dcdc7baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LeftNavigation.vue"
export default component.exports